import { Component, useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import SmoothScroll from "./components/SmoothScroll";
import Nav from "./components/Nav";
import Hero from "./components/Hero";
import Marquee from "./components/Marquee";
import Areas from "./components/Areas";
import Team from "./components/Team";
import Locations from "./components/Locations";
import Footer from "./components/Footer";
import TriageModal from "./components/TriageModal";
import Privacy from "./pages/Privacy";
import AreaPage from "./pages/AreaPage";
import FaqSection from "./components/FaqSection";
import RetirementCheck from "./components/RetirementCheck";
import { scrollToId } from "./components/SmoothScroll";

class ErrorBoundary extends Component {
  state = { failed: false };
  static getDerivedStateFromError() {
    return { failed: true };
  }
  render() {
    if (this.state.failed)
      return (
        <div className="flex min-h-screen items-center justify-center bg-navy-900 text-cream">
          Algo saiu do lugar. Recarregue a página.
        </div>
      );
    return this.props.children;
  }
}

function ScrollManager() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const t = setTimeout(() => scrollToId(hash), 350);
      return () => clearTimeout(t);
    }
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

function Home({ onConsult }) {
  return (
    <main>
      <Hero />
      <Marquee />
      <Areas onConsult={onConsult} />
      <RetirementCheck />
      <Team />
      <FaqSection />
      <Locations />
    </main>
  );
}

export default function App() {
  const [solution, setSolution] = useState(null);

  useEffect(() => {
    const onOpen = (e) => setSolution(e.detail || {});
    window.addEventListener("open-triage", onOpen);
    return () => window.removeEventListener("open-triage", onOpen);
  }, []);

  return (
    <ErrorBoundary>
      <BrowserRouter>
        <SmoothScroll>
          <ScrollManager />
          <div className="bg-navy-900 text-cream">
            <Nav />
            <Routes>
              <Route path="/" element={<Home onConsult={setSolution} />} />
              <Route path="/privacidade" element={<Privacy />} />
              <Route path="/areas/:slug" element={<AreaPage />} />
              <Route path="*" element={<Home onConsult={setSolution} />} />
            </Routes>
            <Footer />
          </div>
          <TriageModal solution={solution} onClose={() => setSolution(null)} />
        </SmoothScroll>
      </BrowserRouter>
    </ErrorBoundary>
  );
}
